// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Heading } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { Main } from "../../../Components";
import { hubsIndexPageInfo } from "./pageinfo";

export function HubsIndexPage() {
	useActivePageRegistration(hubsIndexPageInfo);

	return (
		<Main>
			<Heading.H1>Hubs</Heading.H1>
		</Main>
	);
}
